// Google Tag Manager, configured by the gtm-id meta tag in shared/_analytics.
// Loaded from the pack rather than an inline script so it works with the
// content security policy (strict-dynamic trusts scripts the pack inserts).

const gtmId = document.querySelector("meta[name='gtm-id']")?.content;

if (gtmId) {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({ "gtm.start": new Date().getTime(), event: "gtm.js" });

  const script = document.createElement("script");
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtm.js?id=${encodeURIComponent(gtmId)}`;
  document.head.appendChild(script);
}

// Google Tag Manager trigger for Turbolinks
document.addEventListener("turbolinks:load", function () {
  if (window.dataLayer === undefined) return;

  const url = window.location.href;

  window.dataLayer.push({
    event: "pageView",
    virtualUrl: url,
    eventCallback: function () {
      if (typeof window.gtmCallback === "function") {
        window.gtmCallback.call(url);
        window.gtmCallback = undefined;
      }
    },
  });
});
